import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client";
import { S } from "../../styles";
import {
  LoadingState,
  ErrorState,
  EmptyState,
} from "../../components/QueryStates";

export function RFQList({
  onSelectRFQ,
}: {
  onSelectRFQ: (id: string) => void;
}) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["rfqs"],
    queryFn: () => api.listRFQs(0, 50),
    refetchInterval: 5_000,
  });

  const rfqs = data?.items ?? [];

  if (isLoading) return <LoadingState label="Loading RFQs…" />;
  if (error) return <ErrorState error={error} />;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <h2 style={{ ...S.h2, margin: 0 }}>RFQs ({data?.total ?? 0})</h2>
        <button style={S.btnSm} onClick={() => void refetch()}>
          ↺ Refresh
        </button>
      </div>

      {rfqs.length === 0 && (
        <EmptyState message="No RFQs yet — submit a requirement to get started." />
      )}

      {rfqs.map((rfq) => (
        <div key={rfq.id} style={S.card}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div>
              <span style={{ fontWeight: 700, fontSize: 15 }}>
                {rfq.rfq_number}
              </span>
              <span style={{ ...S.statusBadge(rfq.status), marginLeft: 10 }}>
                {rfq.status}
              </span>
              {rfq.workflow_run_id && (
                <span style={{ ...S.muted, marginLeft: 8, fontSize: 11 }}>
                  ⏱ {rfq.workflow_run_id.slice(0, 12)}…
                </span>
              )}
              {rfq.part_number && (
                <div style={{ ...S.muted, fontSize: 12, marginTop: 3 }}>
                  PN:{" "}
                  <span style={{ fontWeight: 600, color: "#333" }}>
                    {rfq.part_number}
                  </span>
                </div>
              )}
            </div>
            <button
              style={
                rfq.status === "Quoted"
                  ? {
                      ...S.btnSm,
                      background: "#4f46e5",
                      color: "#fff",
                      border: "none",
                    }
                  : S.btnSm
              }
              onClick={() => onSelectRFQ(rfq.id)}
            >
              {rfq.status === "Quoted"
                ? "🤖 Quotes & AI Rec →"
                : "View Quotes →"}
            </button>
          </div>
          <div
            style={{
              ...S.muted,
              marginTop: 6,
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: "4px 16px",
            }}
          >
            <span>Created: {new Date(rfq.created_at).toLocaleString()}</span>
            {rfq.dispatched_at && (
              <span>
                Dispatched: {new Date(rfq.dispatched_at).toLocaleString()}
              </span>
            )}
            {rfq.expires_at && (
              <span>Expires: {new Date(rfq.expires_at).toLocaleString()}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
